<script setup>
import LoginInputEmail from "@/pages/Login/LoginInputEmail.vue";
import { Api } from "@/service/api";
import { ref } from 'vue';
import {validateEmail} from "@/service/utils";
import {createToaster} from "@meforma/vue-toaster";
import LoadingSvg from "@/components/UI/LoadingSvg.vue";


const userEmail = ref("");

const toaster = createToaster({ /* options */ });

const isLoading = ref(false);

const step = ref("email_request")

async function resetPassword() {
    isLoading.value = true;
    if (!validateEmail(userEmail.value)) {
        toaster.error("Значение «Email» не является правильным email адресом.")
        isLoading.value = false;
        return
    }
    const response = await Api.resetPasswordRequest(userEmail.value)
    if (response.status === "error") {
        toaster.error(response.message)
        isLoading.value = false;
        return
    }
    isLoading.value = false;
    step.value = "email_accept"
}

function toFirstStep() {
    step.value = "email_request"
}

</script>

<template>
    <div class="w-full h-screen flex items-center justify-center">
        <div
            class="flex rounded-2xl bg-white justify-center shadow-xl h-[350px] w-[340px]
                   sm:w-[400px]
                   xl:w-[450px]
             "
        >
            <div class="flex w-3/4 mt-14 flex-col" v-if="step === 'email_request'">
                <div class="text-lg font-bold">Введите email, который вы использовали при регистрации</div>
                <div
                    class="flex flex-col"
                >
                    <div class="flex flex-col items-center">
                        <LoginInputEmail class="w-full" v-model="userEmail"/>
                        <div class="flex items-center justify-center h-10 w-full
                                bg-light-blue outline-none rounded-md mt-5
                                text-white font-bold text-sm cursor-pointer
                                bg-blue-600 hover:bg-blue-700
                             "
                             v-on:click="resetPassword"
                             v-if="!isLoading"
                        >
                            Восстановить
                        </div>
                        <div class="flex items-center justify-center h-10 w-full
                                bg-light-blue outline-none rounded-md mt-5
                                text-white font-bold text-sm
                                bg-blue-700
                             "
                             v-else
                        >
                            <LoadingSvg class="size-6 animate-spin"/>
                        </div>

                        <div class="w-full flex justify-between mt-4 px-2">
                            <router-link class="font-bold text-blue-600 hover:text-blue-700" to="/register">Регистрация</router-link>
                            <router-link class="font-bold text-blue-600 hover:text-blue-700" to="/login">Войти</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex w-3/4 mt-14 flex-col" v-if="step === 'email_accept'">
                <div class="text-lg font-bold">Спасибо! Пожалуйста, проверьте свою электронную почту</div>
                <div
                    class="flex flex-col"
                >
                    <div class="mt-5">
                        {{ userEmail }}
                    </div>
                    <div class="flex flex-col items-center">
                        <div class="flex items-center justify-center h-10 w-full
                                bg-light-blue outline-none rounded-md mt-5
                                text-white font-bold text-sm cursor-pointer
                                bg-blue-600 hover:bg-blue-700
                             "
                             v-on:click="toFirstStep"
                             v-if="!isLoading"
                        >
                            Отправить снова
                        </div>
                        <div class="w-full flex justify-between mt-4 px-2">
                            <router-link class="font-bold text-blue-600 hover:text-blue-700" to="/register">Регистрация</router-link>
                            <router-link class="font-bold text-blue-600 hover:text-blue-700" to="/login">Войти</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>